import { Type } from 'class-transformer';
import { IsArray, IsInt, IsString, Min, ValidateNested } from 'class-validator';

/**
 * `{ start, end }` character offsets into `text`, matching the contract of
 * `shared/src/ingredient/allergen-emphasis.ts` (plan.md "Evidenza
 * allergeni"): the renderer bolds these ranges instead of re-searching the
 * text for allergen words.
 */
export class TextEmphasisRangeDto {
  @IsInt()
  @Min(0)
  start!: number;

  @IsInt()
  @Min(0)
  end!: number;
}

export class CounterRegisterIngredientLineDto {
  @IsString()
  text!: string;

  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => TextEmphasisRangeDto)
  emphasis!: TextEmphasisRangeDto[];
}
